// extracted by mini-css-extract-plugin
var _1 = "IneligiblePhotoCapture-module__card--rZHmw";
var _2 = "IneligiblePhotoCapture-module__cardContainer--HEIBV";
var _3 = "IneligiblePhotoCapture-module__continueButton--gDOAV";
var _4 = "IneligiblePhotoCapture-module__ctaTextPrompt--G2uKE";
var _5 = "IneligiblePhotoCapture-module__icoIneligible--gn4zi";
var _6 = "IneligiblePhotoCapture-module__takePhotoImage--GneR4";
export { _1 as "card", _2 as "cardContainer", _3 as "continueButton", _4 as "ctaTextPrompt", _5 as "icoIneligible", _6 as "takePhotoImage" }
